<script setup lang="ts">
import { useDefaultSettingsStore } from "~/stores/defaultSettingsStore"
import { useNotification } from "~/composables/ShowNotification"

/**
 *
 *  Props and emits section
 *
 *
*/

/**
 *
 *  Ref, computed and hooks section
 *
 *
*/

const defaultSettingsStore = useDefaultSettingsStore()
const notify = useNotification()

/**
 *
 *  Life cicle events
 *
 *
*/

/**
 *
 *  Functions section
 *
 *
*/

function openEmail() {
    try {
        const correoURL = `mailto:${defaultSettingsStore?.settings?.contacts?.email}`;
        window.open(correoURL);
    } catch (error) {
        notify("negative", "No se pudo abrir el correo")
        console.error(error)
    }
}

function openWhatsapp() {
    try {
        const whatsappURL = `https://wa.me/${defaultSettingsStore?.settings?.contacts?.phones[0]}`
        window.open(whatsappURL)
    } catch (error) {
        notify("negative", "No se pudo abrir el whatsapp")
        console.error(error)
    }
}
</script>

<template>
    <div class="tw-fixed tw-bottom-10 tw-right-10 tw-self-end tw-z-[9999999999999999]">
        <q-fab
            vertical-actions-align="right"
            color="primary"
            glossy
            icon="comment"
            direction="up"
            class="tw-z-50"
        >
            <q-fab-action
                label-position="left"
                color="primary"
                @click="openEmail"
                icon="email"
            />
            <q-fab-action
                label-position="left"
                color="secondary"
                @click="openWhatsapp"
                icon="fa-brands fa-whatsapp"
            />
        </q-fab>
    </div>
</template>
